import { jsx as _jsx } from "react/jsx-runtime";
import styles from './TextLink.module.css';
export function TextLink({ linkAs, className, tone = 'primary', ...rest }) {
    const Anchor = linkAs ?? 'a';
    const base = tone === 'inherit' ? `${styles.textLink} ${styles.inherit}` : styles.textLink;
    const composed = className ? `${base} ${className}` : base;
    return _jsx(Anchor, { className: composed, ...rest });
}
//# sourceMappingURL=TextLink.js.map